import WithService from './with-service';
export default WithService;